import { AppointmentEvent, toIcsDateTime } from './appointment-ics';

const toIsoDateTime = (value: string): string =>
  `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)}T${value.slice(8, 10)}:${value.slice(10, 12)}:00`;

const toQuery = (params: Record<string, string | undefined>): string =>
  Object.entries(params)
    .flatMap(([key, value]) => (value === undefined ? [] : [`${key}=${encodeURIComponent(value)}`]))
    .join('&');

/** Times without zone, like the .ics: the calendar reads them in its user's zone. */
export function buildGoogleCalendarUrl(event: AppointmentEvent): string {
  return `https://calendar.google.com/calendar/render?${toQuery({
    action: 'TEMPLATE',
    text: event.title,
    dates: `${toIcsDateTime(event.start)}/${toIcsDateTime(event.end)}`,
    location: event.location,
  })}`;
}

/** Times without zone, like the .ics: the calendar reads them in its user's zone. */
export function buildOutlookCalendarUrl(event: AppointmentEvent): string {
  return `https://outlook.live.com/calendar/0/action/compose?${toQuery({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: event.title,
    startdt: toIsoDateTime(event.start),
    enddt: toIsoDateTime(event.end),
    location: event.location,
  })}`;
}
